module.exports = __webpack_public_path__ + "img/forward_to_inbox.8f8aacc1.svg";